var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppView',{staticClass:"contest-game"},[_c('TheGame',{on:{"end":function($event){return _vm.onGameEnd($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }